goog.provide("shadow.js.shim.module$$mui$material$FormGroup");
goog.provide("module$shadow_js_shim_module$$mui$material$FormGroup");
shadow.js.shim.module$$mui$material$FormGroup = shadow.js.nativeProvides["@mui/material/FormGroup"] = shadow$bridge("@mui/material/FormGroup");
module$shadow_js_shim_module$$mui$material$FormGroup.default = shadow.js.shim.module$$mui$material$FormGroup;
